import { render, staticRenderFns } from "./config026-f-dimming3.vue?vue&type=template&id=882bfbe6&"
import script from "./config026-f-dimming3.vue?vue&type=script&lang=js&"
export * from "./config026-f-dimming3.vue?vue&type=script&lang=js&"
import style0 from "./config026-f-dimming3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports